module.exports = __webpack_public_path__ + "static/media/6_ANNUAL_REPORT_FORM_20160622.f63a457f.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2016/6_ANNUAL_REPORT_FORM_20160622.pdf
// module id = 169
// module chunks = 0